module.exports = __webpack_public_path__ + "c50278ea2ca48dbbb9a8a05a21438237.gif";